import { Button, Container, Group, Paper, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { localePath } from '#marketing/lib/marketing-locale.js';
import { useMarketingLocale } from '#marketing/lib/use-marketing-locale.js';
import { FeatureDomainSections } from './FeatureDomainSection.jsx';
import { MarketingSection } from './MarketingSection.jsx';

/**
 * Public /features page — domain sections and pilot CTA.
 */
export function MarketingFeaturesPage() {
  const { t } = useTranslation('common');
  const locale = useMarketingLocale();

  return (
    <>
      <Container size="lg" py="xl" pb="xl">
        <MarketingSection
          titleKey="marketing.featuresPage.heroTitle"
          descriptionKey="marketing.featuresPage.heroDescription"
        />
        <FeatureDomainSections />
      </Container>

      <Container size="lg" pb="xl">
        <Paper
          withBorder
          shadow="sm"
          radius="md"
          p="xl"
          bg="pachubColourScheme.0"
          ta="center"
        >
          <Text fw={700} size="xl" mb="sm">
            {t('marketing.featuresPage.pilotCtaTitle')}
          </Text>
          <Text c="dimmed" maw={520} mx="auto" mb="lg">
            {t('marketing.featuresPage.pilotCtaDescription')}
          </Text>
          <Group justify="center">
            <Button component={Link} to={localePath(locale, '/contact')} size="md" color="pachubColourScheme">
              {t('marketing.featuresPage.pilotCtaButton')}
            </Button>
          </Group>
        </Paper>
      </Container>
    </>
  );
}
